import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalTimesheetDosService {
  constructor() {}
  private userAccessChangeSubject = new BehaviorSubject<boolean>(false);
  readonly userAccessChangeAction$ = this.userAccessChangeSubject.asObservable();

  isAccessChangeAccepted(): boolean {
    const isChangeAccepted = this.userAccessChangeSubject.value;
    return isChangeAccepted;
  }

  changeAccessLevel(valueChanged: boolean): void {
    this.userAccessChangeSubject.next(valueChanged);
  }
}
